import { render, staticRenderFns } from "./TermsConditionsView.vue?vue&type=template&id=5d18ef65&"
import script from "./TermsConditionsView.vue?vue&type=script&lang=ts&"
export * from "./TermsConditionsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports